module.exports = __webpack_public_path__ + "static/media/new-people.71e532cf.png";